export default class NavDropdown {
  constructor(el) {
    this.countDownEl = el;
    this.daysEl = this.countDownEl.querySelector("[data-days]");
    this.hoursEl = this.countDownEl.querySelector("[data-hours]");
    this.minutesEl = this.countDownEl.querySelector("[data-minutes]");
    this.date = this.countDownEl.dataset.countdown;

    this.bindEvents();
    this.updateCountdown();
  }

  bindEvents() {
    const timeRemaining = this.getTimeRemaining();

    if (timeRemaining > 0) {
      setInterval(this.updateCountdown, 60 * 1000);
    }
  }

  getTimeRemaining = () => {
    const now = new Date();
    const today = new Date(now.toLocaleString("en-US", { timeZone: "UTC" }));
    const date = new Date(this.date);
    return parseInt((date - today) / 1000);
  };

  updateCountdown = () => {
    let timeRemaining = this.getTimeRemaining();

    if (timeRemaining < 0) return;

    const days = parseInt(timeRemaining / 86400);
    timeRemaining = timeRemaining % 86400;
    const hours = parseInt(timeRemaining / 3600);
    timeRemaining = timeRemaining % 3600;
    const minutes = parseInt(timeRemaining / 60);

    if (this.daysEl) this.daysEl.innerHTML = days;
    if (this.hoursEl) this.hoursEl.innerHTML = hours;
    if (this.minutesEl) this.minutesEl.innerHTML = minutes;
  };
}
